import ToastMessage from '.';

export const ToastMessageGcpErrorWrapper = () => {
  const gcpErrorMessage = '';

  return (
    <>
      {gcpErrorMessage && (
        <ToastMessage duration={5000} message={gcpErrorMessage} />
      )}
    </>
  );
};
